import theme from "@theme/index";
import { CSSProperties, JSX } from "react";
import SmallSpinner from "@components/ui/loading/SmallSpinner";

interface SecondaryButtonProps {
  children?: JSX.Element | JSX.Element[] | string;
  label?: string;
  onClick?: () => void;
  style?: CSSProperties;
  startIcon?: JSX.Element;
  variant?: "small" | "large";
  danger?: boolean;
  disabled?: boolean;
  loading?: boolean;
}

export default function SecondaryButton({
  children,
  onClick,
  style,
  label,
  startIcon,
  variant,
  danger = false,
  disabled = false,
  loading = false,
}: SecondaryButtonProps) {
  const isDisabled = disabled || loading;
  return (
    <button
      className={`${variant === "small" ? "px-3 py-1 rounded-lg font-medium" : "px-4 py-3 rounded-xl font-semibold  "}  items-center text-h2 w-fit flex flex-row gap-4  hover:ring-2 hover:ring-neutral-300
      ${danger ? " border border-red-200 text-red-500 cursor-pointer hover:bg-red-500 hover:text-white" : " "}
      border
      ${isDisabled ? "opacity-50 cursor-not-allowed hover:ring-0 bg-neutral-300 text-neutral-500 " : "hover:bg-neutral-100 bg-white cursor-pointer text-neutral-800"}
      `}
      onClick={() => !isDisabled && onClick && onClick()}
    >
      {loading ? <SmallSpinner size={16} margin={2} /> : startIcon} {label || children}
    </button>
  );
}
